module.exports = __webpack_public_path__ + "static/img/dafeng.1329a07f.png";